import React, {useState} from "react";
import {Col, Form, Row} from "react-bootstrap";
import {translation} from "../../../../../I18n/i18n";
import Grid from "@mui/material/Grid";
import Button from "../../../../UI/Button/Button";


const FormLinguisticSkill = (props) => {
    const [code, setCode] = useState(props.language ? props.language.code._text : "");
    const [level, setLevel] = useState(props.language ? props.language.level._text : "");
    let isSaveBtnDisabled = () => {
        //Disable if code , level is not defined
        let valid = code.length > 0 && level.length > 0;
        return !valid;
    }
    return (
        <>
            <Form>
                <Form.Group as={Row}>
                    <Form.Label column sm="2">{translation(props.lang, "Language")}</Form.Label>
                    <Col sm="10">
                        <Form.Control as="select" value={code} disabled={false}
                                      onChange={(e) => {
                                          setCode(e.target.value)
                                      }}>

                            <option value="">---- {translation(props.lang, "Select")} ----</option>

                            { props.language.code._text &&
                                <option value={props.language.code._text}> {translation(props.lang, props.computeLabel(props.language.code._text))}</option> }

                            { props.languageList.map ((l,i) => {
                                return <option key={i} value={ l.code }> { translation (props.lang, l.label) }</option>
                            })
                            }

                        </Form.Control>
                    </Col>
                </Form.Group>

                <Form.Group as={Row}>
                    <Form.Label column sm="2">{translation(props.lang, "Level")}</Form.Label>
                    <Col sm="10">
                        <Form.Control as="select" value={level} disabled={false}
                                      onChange={(e) => {
                                          props.language.level._text = e.target.value;
                                          setLevel(e.target.value)
                                      }}>
                            <option value=""> ---- {translation(props.lang, "Select")} ----</option>
                            <option value="Mother tongue">{translation(props.lang, "Mother tongue")}</option>
                            <option value="Good Knowledge">{translation(props.lang, "Good Knowledge")}</option>
                            <option value="Fluent">{translation(props.lang, "Fluent")}</option>
                            <option value="Passive Knowledge">{translation(props.lang, "Passive Knowledge")}</option>
                        </Form.Control>
                    </Col>
                </Form.Group>
            </Form>
           {/* <CardActions>*/}
                <Grid  container spacing={3}>
                    <Grid item xs={10}></Grid>
                    <Grid item xs={1} style={{padding: '20px 2px 20px 2px'}}>
                        <Button
                            label={translation(props.lang, props.buttonTitle)}
                            isDisabled={isSaveBtnDisabled()}
                            variant="success"
                            isVisible={true}
                            size="sm"
                            loading={props.loading}
                            actionHandler={() => {
                                props.language.code = {_text: code };
                                props.language.level = {_text: level };
                                props.submit()
                            }}/>
                    </Grid>
                    <Grid item xs={1} style={{padding: '20px 0px 2px 2px'}}>
                        <Button
                            label={translation(props.lang, "Cancel")}
                            variant="danger"
                            isVisible={true}
                            size="sm"
                            loading={props.loading}
                            actionHandler={props.cancel}/>
                    </Grid>
                </Grid>
            {/*</CardActions>*/}
        </>

    );
};

export default FormLinguisticSkill;
